import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import 'font-awesome/css/font-awesome.min.css'
import '../util/globalStyle.css'

import './promissionRouter'//这里进行路由后台获取的模拟

import longpress from '../util/longpress' // 监听长按事件的指令

Vue.use(ElementUI);
Vue.directive('longpress', longpress)

Vue.config.productionTip = false

Vue.prototype.$getEnvInfo = function (domain) {
  let envInfo = {
    'BUCKET_NAME':process.env.VUE_APP_BUCKET_NAME,
    'ACCESS_KEY_ID':process.env.VUE_APP_ACCESS_KEY_ID,
    'SECRET_ACCESS_KEY':process.env.VUE_APP_SECRET_ACCESS_KEY,
    'BASE_URL':process.env.VUE_APP_BASE_URL,
    'SERVER_ACCESS_AREA':process.env.VUE_APP_SERVER_ACCESS_AREA,
    'SERVER_ACCESS_AREA_A':process.env.VUE_APP_SERVER_ACCESS_AREA_A
  }
  
  if(domain != null && domain !== process.env.VUE_APP_DOMAIN){
    envInfo['BUCKET_NAME'] = process.env.VUE_APP_TEST_BUCKET_NAME;
    envInfo['ACCESS_KEY_ID'] = process.env.VUE_APP_TEST_ACCESS_KEY_ID;
    envInfo['SECRET_ACCESS_KEY'] = process.env.VUE_APP_TEST_SECRET_ACCESS_KEY;
    envInfo['BASE_URL'] = process.env.VUE_APP_TEST_BASE_URL;
  }
  return envInfo;
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
